export default "__VITE_ASSET__e4e97df5__$_?nuxt_component=async&nuxt_component_name=SvgoGgBg2__"